namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiPickerDialog extends Serenity.TemplatedDialog<ProdottiPickerOptions> {

        private checkGrid: ProdottiCheckGrid;

        constructor(opt: ProdottiPickerOptions) {
            super(opt);

            this.checkGrid = new ProdottiCheckGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "Seleziona i Prodotti desiderati";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.checkGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Seleziona almeno un elemento!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
        }

        get selectedItems() {
            return this.checkGrid.selectedItems;
        }

        public onSuccess: (selected: Gamification.ProdottiRow[]) => boolean;
    }
}